import './styles.scss'
import * as React from 'react'

import DaysRange from '../DaysRange'
import { SelectWithLabel } from 'components/Form'
import { lang } from 'utils/helpers'

const Index = (props) => {
  const [selectedOptionAi, setSelectedOptionAi] = React.useState({ value: '', label: lang('dashboard_every-day') })
  const [shouldRefresh, setShouldRefresh] = React.useState(false)
  const [aiBotSchedules, setAiBotSchedules] = React.useState({
    monday: props.schedules[0].monday,
    tuesday: props.schedules[0].tuesday,
    wednesday: props.schedules[0].wednesday,
    thursday: props.schedules[0].thursday,
    friday: props.schedules[0].friday,
    saturday: props.schedules[0].saturday,
    sunday: props.schedules[0].sunday,
  })
  const SCHEDULE_DAYS = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday'
  ]
  const options = [
    lang('dashboard_every-day'),
    lang('dashboard_weekday'),
    lang('dashboard_personalized')
  ]

  const updateSchedule = ({ schedule, isActiveChange = false }) => {
    const isActive = !!SCHEDULE_DAYS.find(elem => schedule[elem].isActive)

    setAiBotSchedules(schedule)
    props.onChange({ ...schedule, isActive })
    if (isActiveChange) {
      setSelectedOptionAi({ value: options[2], label: options[2] })
    }
    setShouldRefresh(!shouldRefresh)
  }

  const changeDaysSelector = ({ d }) => {
    setSelectedOptionAi(d)
    let newSchedule = aiBotSchedules
    if (d.value === options[0]) {
      Object.keys(newSchedule).forEach((day) => {
        newSchedule[day].isActive = true
      })
    } else if (d.value === options[1]) {
      Object.keys(newSchedule).forEach((day) => {
        if (day === 'saturday' || day === 'sunday') {
          newSchedule[day].isActive = false
        } else {
          newSchedule[day].isActive = true
        }
      })
    }

    setAiBotSchedules(newSchedule)
    setShouldRefresh(!shouldRefresh)
  }

  return (
    <div className='notification-schedules-container'>
      <div className='bot-modal'>
        <div className='days-selector-container'>
          <SelectWithLabel
            label={lang('dashboard_weekdays')}
            options={options.map((o) => ({ value: o, label: o }))}
            value={selectedOptionAi}
            onChange={d => changeDaysSelector({ d })}
          />
        </div>
        <div className='days-range-container'>
          <DaysRange
            schedules={aiBotSchedules}
            updateSchedule={updateSchedule}
            scheduleName='aiBotSchedules'
            refresh={shouldRefresh}
            onChangeError={props.setRangeError}
          />
        </div>
      </div>
    </div>
  )
}

export default Index
